const activityCenter = {
  title: 'Centro de atividade',
  noRecentActivity: 'Sem atividade recente',
  inProgress: 'A gerar ficheiro',
};

export default { activityCenter };
